import 'regenerator-runtime/runtime';
import 'slick-carousel';

import branchBar from './modules/branch-bar';

// jQuery scripts
import analytics from './modules/analytics.js';
import globals from './modules/globals.js';
import omalaakkonen from './modules/omalaakkonen.js';
import tools from './modules/tools.js';
import dropdown from './modules/dropdown';

// Generic scripts
import generic from './modules/generic';

import HedinAccordion from './modules/car-search/2022/hedin-accordion';
import autosivu from './modules/autosivu/autosivu';
import shared from './modules/shared/shared';

import forms from './modules/forms/forms';

import maps from './modules/maps/maps.js';
import DistanceHolder from './modules/distance-holder';

import ShoppingCartIndicator from './modules/shopping-cart/2023/shopping-cart-indicator';
import ShoppingCart from './modules/shopping-cart/2023/shopping-cart';

import cmtoken from './modules/cmtoken';

import { searchAndReplaceDOM } from './modules/v10/url-to-links';

/**
 * V10 imports
 */
import v10navigation from './modules/v10/navigation';
import { SiteSearch } from './modules/v10/site-search';
import ticker from './modules/v10/ticker';
import FrontPageCarousels from './modules/v10/frontpage-carousel.js';
import EmissionOffset from './modules/v10/emission-offset';
import EmissionComparison from './modules/v10/emission-comparison';
import CampaignContact from './modules/v10/campaign-contact-form';
import { NewsCarousel } from './modules/v10/news-carousel';
import CountdownTimer from './modules/v10/countdown-timer';
import modals from './modules/v10/modals';
import remultiselect from './modules/multiselect/multiselect';
import FormSend from './modules/v10/form-send-module';

import HeroBannerFilters from './modules/v10/hero-banner-filters';
import StickyColumn from './modules/v10/sticky-column';
import FormV10 from './modules/v10/form/form-v10';
import Tabs from './modules/generic/tabs';
import AnchorLinks from './modules/generic/anchor-links';
import { CarPurchaseDraft } from './modules/v10/car-purhcase-draft';
import { CarSellForm } from './modules/v10/car-sell-form';
import CollapseContainer from './modules/generic/collapse-container';
import Collapsible from './modules/generic/collapsible';
import TriggerButton from './modules/generic/trigger-button';
import FiksudiiliSearch from './modules/v10/fiksudiili-search';
import ABTesting from './modules/v10/ab-testing';
import NumberValuesObserver from './modules/generic/number-values-observer';
import {PredictingInputField} from './modules/generic/predicting-input-field';
import carSearch from './modules/car-search/car-search';
import ModelPageSearch from './modules/model-page/2022/model-page-search';
import TestDrive from './modules/test-drive/2022/test-drive';
import TestDriveSelection from './modules/test-drive/2024/test-drive-selection.js';
import { IncomingCarNotificationForm } from './modules/incoming-car-notification-form';
import BrandsAndModels from './modules/v10/brands-and-models';
import TextInput from './modules/v10/form/text-input';
import SearchWatcherCarList from './modules/search-watcher-car-list.js';

import SharedCarPageTalkbackForm from './modules/shared/2023/car-page-talk-back-form';

// Custom Elements
import RadioGroup from './modules/v10/customelements/radio-group';

// Register custom elements
window.customElements.define('radio-group', RadioGroup);

// Components
import ImageCarousels from './modules/v10/components/car/car-image-carousel.js';

import DateInput from './modules/v10/date-input';
import StageTokenUpdates from './modules/v10/stage-token-updates';
import SkipToContent from './modules/skip-to-content.js';

// Stores
import StoreCollection from './modules/stores/store-collection';
import Store from './modules/stores/store';

// Phonebbok
import Phonebook from './modules/v10/phonebook';
import ContactForm from './modules/v10/form/contact-form';
import TimePicker from './modules/shared/time-picker.js';

//HedinDrive
import HedinDriveContactForm from './modules/hedindrive/hedindrive-contact-form';
import HedinDriveCalculator from './modules/hedindrive/hedindrive-calculator';
import HedinDriveSimplifiedSearch from './modules/hedindrive/hedindrive-simplified-search';

// New navigation
import Navigation from './modules/navigation';

document.addEventListener('DOMContentLoaded', () => {
  branchBar.init();

  HedinAccordion.init();

  generic.init();
  ticker.init();
  tools.init();
  analytics.init();
  cmtoken.init();
  modals.init();
  dropdown.init();
  remultiselect.init();
  CarSellForm.init();
  autosivu.init();
  carSearch.init();
  shared.init();
  forms.init();
  IncomingCarNotificationForm.init();
  TextInput.init();
  TimePicker.init();
  SearchWatcherCarList.init();
  Navigation.init();

  /**
   * V10 initializations
   */
  DateInput.init();
  new StageTokenUpdates();
  v10navigation.init();

  FrontPageCarousels.init();
  FormSend.init();
  StickyColumn.init();
  FiksudiiliSearch.init();
  Tabs.init();
  AnchorLinks.init();
  CollapseContainer.init();
  Collapsible.init();
  TriggerButton.init();
  FormV10.init();
  NumberValuesObserver.init();
  PredictingInputField.init();

  SharedCarPageTalkbackForm.init();

  StoreCollection.init();
  Store.init();

  Phonebook.init();

  HedinDriveContactForm.init();
  HedinDriveCalculator.init();
  HedinDriveSimplifiedSearch.init();

  new EmissionOffset();
  new CampaignContact();
  new NewsCarousel();
  HeroBannerFilters.init();
  CarPurchaseDraft.init();
  ModelPageSearch.init();
  TestDrive.init();
  TestDriveSelection.init();
  DistanceHolder.init();
  ContactForm.init();

  // Components
  ImageCarousels.init();
  BrandsAndModels.init();

  // Init all countdowns
  CountdownTimer.init();

  ShoppingCartIndicator.init();
  ShoppingCart.init();
  SkipToContent.init();

  searchAndReplaceDOM();

  maps.init();

  if (document.querySelector('.emission-comparison')) new EmissionComparison();

  if (document.querySelector('header') && document.querySelector('header .site-search')) {
    new SiteSearch(document.querySelector('header .site-search'));
  }

  // Omalaakkonen disable register button when form submit
  if (document.getElementById('register-ol')) {
    omalaakkonen.disableRegisterButton();
  }

  if (document.getElementById('omalaakkonen')) {
    omalaakkonen.init();
  }

  if (document.querySelector('.omalaakkonen-app .infobox')) {
    omalaakkonen.hideInfobox();
  }

  if (document.querySelector('.omalaakkonen-app .infobox .hedin-btn')) {
    omalaakkonen.closeInfobox();
  }

  if (globals.loggedUser) {
    document.querySelector('body').classList.add('logged');
  }

  const videoDialogElements = document.querySelectorAll('.video-dialog');

  if (videoDialogElements) {
    import(/* webpackChunkName: "video-dialog" */ './modules/videodialog.js').then(({ default: VideoDialog }) => {
      videoDialogElements.forEach((element) => {
        new VideoDialog(element);
      });
    });
  }


  // Not super happy with using a timeout, but without it there's some conflicting scrolling thing that overrides whatever this tries to do. Tried to track down what it was but not entirly sure what is doing it.
  setTimeout(() => {
    // If there are errors on any submitted Stage form, this will automatically scroll to the first occurrence, helping the user to see the error message better.
    const errorField = document.querySelector('form:not(.custom-error-handling) input.stage-error');
    if (errorField instanceof HTMLElement) errorField.scrollIntoView({ behavior: 'smooth' });
  }, 500);

  const abTesting = new ABTesting();
  abTesting.init();
});

document.addEventListener('scroll', (e) => {
  omalaakkonen.onScroll();
});

window.addEventListener('resize', (e) => {
  tools.articlePageHeights();
});
